// icons
import { MdRequestQuote, MdAdd, MdList, MdHistory, MdPeople, MdFilterAlt } from "react-icons/md";

const cotizaciones = {
  id: 'cotizaciones-group',
  type: 'group',
  roles: [1, 100, 110],
  breadcrumbs: false,
  children: [
    {
      id: 'cotizaciones',
      title: "CRM",
      type: 'collapse',
      icon: MdRequestQuote,
      children: [
        {
          id: 'funnel-de-ventas',
          title: "Funnel de ventas",
          type: 'item',
          breadcrumbs: false,
          icon: MdFilterAlt,
          url: '/cotizaciones/funnel-de-ventas'
        },
        {
          id: 'clientes',
          title: "Clientes",
          type: 'item',
          breadcrumbs: false,
          icon: MdPeople,
          url: '/cotizaciones/clientes'
        },
        {
          id: 'nueva-cotizacion',
          title: "Nueva Cotización",
          type: 'item',
          breadcrumbs: false,
          icon: MdAdd,
          url: '/cotizaciones/nueva-cotizacion'
        },
        {
          id: 'cotizaciones-list',
          title: "Cotizaciones",
          type: 'item',
          breadcrumbs: false,
          icon: MdList,
          url: '/cotizaciones/cotizaciones'
        },
        {
          id: 'historico-cotizaciones',
          title: "Histórico de Cotizaciones",
          type: 'item',
          breadcrumbs: false,
          icon: MdHistory,
          url: '/cotizaciones/historico-cotizaciones'
        }
      ]
    }
  ]
};

export default cotizaciones;
